import { useSilentAwaken } from '~/utils/active/use-silent-awaken';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { DeepLinkBuildingProps } from '~/utils/active/schema';
import { $CurrentDiscoverData, $CurrentDiscoverStandardKeyword } from '@discover/shared/atom';

export const KEPSilentAwaken = () => {
  const standardKeyword = useAtomValue($CurrentDiscoverStandardKeyword);
  const kepData = useAtomValue($CurrentDiscoverData);

  const hasFulfilled: boolean = useMemo(() => {
    return Boolean(kepData.query);
  }, [kepData.query]);

  const schemaOption: DeepLinkBuildingProps = useMemo(() => {
    return { pageType: 'search', query: standardKeyword };
  }, []);

  useSilentAwaken({
    schemaOption,
    hasFulfilled,
  });

  return <></>;
};
